import styled from 'styled-components';

const AppContainer = styled.div`
  width: 100%;
  max-width: 100%;
`;

export default AppContainer;
